import api from '@/utils/api'

export default {
    createSession: async({ commit }, phoneNumber) => {
        await api({ method: 'post', url: '/sessions', data: { phoneNumber }})
            .then(res => {
                if (res.data) {
                    commit('refRegister/SET_CONFIRMED_LENGTH', res.data['confirmCodeFormat.length'], { root: true })
                    commit('refRegister/SET_SESSION_TOKEN', res.data.token, { root: true })
                }
            })
    },

    confirmSession: async({ dispatch, commit, state }, data) => {
        await dispatch('checkReferralCode', { referralCode: data.referralCode, isSetStatus: false })

        if (state.refStatus === 'invalidCode') {
            return
        }

        return api({ method: 'post', url: '/sessions/confirmation', data })
            .then(res => {
                if (res.data && res.data.confirmed) {
                    dispatch('refRegister/updateProfile', data, { root: true })
                }
                if (res.status === 205) {
                    dispatch('addMessage', {
                        status: 'error',
                        message: 'isCodeValid',
                        locale: true
                    }, { root: true })
                    commit('refRegister/SET_REF_STATUS', 'validCode', { root: true })
                }

                return res.status
            })
            .catch(_ => {
                dispatch('addMessage', {
                    status: 'error',
                    message: 'isCodeValid',
                    locale: true
                }, { root: true })
            })
    },

    checkReferralCode: async({ commit }, data) => {
        const { referralCode, isSetStatus = true } = data
        commit('refRegister/SET_REFERRAL_CODE', referralCode, { root: true })
        await api({ method: 'get', url: '/profile/check-referral-code', params: { referralCode }})
            .then(res => {
                if (isSetStatus) {
                    if (res.data && res.data.referralCodeExist) {
                        commit('refRegister/SET_REF_STATUS', 'validCode', { root: true })
                    } else {
                        commit('refRegister/SET_REF_STATUS', 'invalidCode', { root: true })
                    }
                }
            })
    },

    updateProfile: async({ dispatch, commit }, data) => {
        await api({ method: 'put', url: '/profile', data })
            .then(_ => {
                commit('refRegister/SET_REF_STATUS', 'registered', { root: true })
            })
            .catch(_ => {
                dispatch('addMessage', {
                    status: 'error',
                    message: 'isAccountExist'
                }, { root: true })
            })
    }
}
